import { combineReducers } from 'redux';
import phenologyGeneralReducer from './general/reducer';
import phenologySpecificReducer from './specific/reducer';

const phenologyReducer = combineReducers({
    general: phenologyGeneralReducer,
    specific: phenologySpecificReducer,
});

export default phenologyReducer;